import { useState, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { Avatar, Box, CircularProgress, Alert, AlertTitle, Stack, Button, Typography, Tooltip, IconButton } from '@mui/material';

import copy from "copy-text-to-clipboard";

import { pb } from "../utilities/pocketbase";

import Approve from "../components/Approve";
import FinalistDetails from '../components/FinalistDetails';
import ExamView from "./ExamView"
import FinalExamView from './FinalExamView';
import FinalistInstructions from '../components/FinalistInstructions';

import CRRaoAIMSCSLogo512 from '../crrao_aimscs_logo-512-min.png';

import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ContentCopyIcon from '@mui/icons-material/ContentCopy'

export default function Dashboard() {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState("")
    const [isFinalist, setIsFinalist] = useState(false)
    const [showExamResult, setShowExamResult] = useState(false)
    const [finalistCredentials, setFinalistCredentials] = useState()
    const [sendRequest, setSendRequest] = useState(false)

    const navigate = useNavigate();

    useEffect(() => {
        if (pb?.authStore?.model?.id && pb?.authStore?.model?.collectionName === 'examinees') {
            setLoading(true)
            console.log(pb?.authStore?.model?.id)
            pb.collection('finalist_examinee_ids').getOne(pb?.authStore?.model?.id).then(finalistId => {
                console.log("✅ finalist ✅", finalistId)
                setIsFinalist(true)
                setLoading(false)
                pb.collection('finalist_creds').getFirstListItem(`examinee = "${pb?.authStore?.model?.id}"`).then(record => {
                    if (record) {
                        setFinalistCredentials(record)
                    }
                }).catch(err => {
                    console.log(err)
                })
            }).catch(err => {
                console.log("❌ not a finalist! ❌", err)
                setIsFinalist(false)
                setLoading(false)
                setError(err?.message)
            })

        }

    }, [])

    useEffect(() => {
        if (sendRequest && finalistCredentials?.username && finalistCredentials?.password) {
            setError("")
            pb.collection(`finalists`).authWithPassword(finalistCredentials?.username, finalistCredentials?.password).then(record => {
                // console.log("login record:", record)
                // console.log(pb.authStore.isValid);
                // console.log(pb.authStore.token);
                console.log(pb.authStore.model.id);
                navigate('/')
            }).catch(error => {
                console.log("login error:", error)
                setError(error?.message)
            }).finally(() => setSendRequest(false))
        }
    }, [sendRequest, finalistCredentials?.username, finalistCredentials?.password, navigate])

    return (
        <>
            {loading && <Stack justifyContent={"center"} alignItems={"center"} height={window.innerHeight - 200}>
                <CircularProgress sx={{ color: "GrayText" }} size={100} />
            </Stack>}
            {!loading && !showExamResult && pb?.authStore?.model?.collectionName === 'examinees' && isFinalist && <Stack sx={{ p: 2 }} spacing={2} justifyContent={"center"} alignItems={"center"} >
                {/* <Avatar src={CRRaoAIMSCSLogo512} variant='rounded' sx={{ background: "transparent", height: 200, width: 200, justifyContent: "center" }} /> */}
                <Alert sx={{ border: 2, borderRadius: 3 }} icon={false}>
                    <AlertTitle>Congratulations</AlertTitle>
                    <Typography variant='h4' align='center'>{[pb?.authStore?.model?.firstname, pb?.authStore?.model?.lastname].join(" ")}</Typography>
                    {pb?.authStore?.model?.username && <Typography variant='subtitle2' fontFamily={"JetBrains Mono"} align='center'>{pb?.authStore?.model?.username}</Typography>}
                    <Typography variant='h6' align='center'>
                        You are a finalist for the Statistics Olympiad 2024 final exam, conducted by CR Rao AIMSCS.
                    </Typography>

                    {finalistCredentials && finalistCredentials?.username && finalistCredentials?.password && <Button variant='contained' color='success' onClick={() => setSendRequest(true)} endIcon={<ArrowForwardIcon />} sx={{ textTransform: "none", p: 2, mt: 2 }} fullWidth>Login as finalist</Button>}
                </Alert>

                {/* {finalistCredentials && finalistCredentials?.username && finalistCredentials?.password && <Alert severity='info' icon={false} sx={{ justifyContent: "center", borderRadius: 3, border: 2 }}>
                    <AlertTitle>
                        Your Finalist Credentials
                    </AlertTitle>

                    <Stack spacing={1}>
                        <Stack direction={"row"} spacing={2} justifyContent={"space-between"} alignItems={"center"}>
                            <Typography variant='h6' fontFamily={"JetBrains Mono"}>
                                Username: {finalistCredentials?.username}
                            </Typography>
                            <Tooltip placement='right' arrow title={"Copy to clipboard"}>
                                <IconButton onClick={() => copy(finalistCredentials?.username)}><ContentCopyIcon fontSize='small' /></IconButton>
                            </Tooltip>
                        </Stack>

                        <Stack direction={"row"} spacing={2} justifyContent={"space-between"} alignItems={"center"}>
                            <Typography variant='h6' fontFamily={"JetBrains Mono"}>
                                Password: {finalistCredentials?.password}
                            </Typography>
                            <Tooltip placement='right' arrow title={"Copy to clipboard"}>
                                <IconButton onClick={() => copy(finalistCredentials?.password)}><ContentCopyIcon fontSize='small' /></IconButton>
                            </Tooltip>
                        </Stack>

                        <Button variant='contained' onClick={() => setSendRequest(true)} endIcon={<ArrowForwardIcon />} sx={{ textTransform: "none", p: 1 }} fullWidth>Login as finalist</Button>
                    </Stack>
                </Alert>} */}

                <Alert sx={{ border: 2, borderRadius: 3, maxWidth: "sm" }} icon={false} severity='info'>
                    <AlertTitle>Exam Information</AlertTitle>
                    The exam will monitor the examinee through the camera the whole duration of the exam.
                </Alert>
                <Stack spacing={2}>
                    <Button color='warning' sx={{ border: 2, borderRadius: 3, p: 2 }} component={Link} to={"/finalistInfo"}>
                        Finish your full profile to attend the final exam
                    </Button>
                    <Button color='secondary' sx={{ border: 2, borderRadius: 3, p: 2 }} onClick={() => setShowExamResult(true)}>
                        Show preliminary exam result
                    </Button>
                </Stack>
                <Box sx={{ p: 2, border: 1, borderRadius: 3, borderColor: "divider" }}>
                    <FinalistInstructions />
                </Box>
            </Stack >}
            {!loading && pb?.authStore?.model?.collectionName === 'examinees' && isFinalist && showExamResult && <Stack justifyContent={"center"} alignItems={"center"}>
                <Button sx={{ px: 2, py: 1, borderRadius: 12, m: 2, border: 2 }} startIcon={<ArrowBackRoundedIcon />} onClick={() => setShowExamResult(false)} >Go Back</Button>
            </Stack>}
            {!loading && pb?.authStore?.model?.collectionName === 'examinees' && isFinalist && showExamResult && <ExamView />}
            {!loading && pb?.authStore?.model?.collectionName === 'examinees' && !isFinalist && <ExamView />}
            {!loading && pb?.authStore?.model?.collectionName === 'finalists' && <FinalExamView />}
            {pb?.authStore?.model?.collectionName === 'supervisors' && pb.authStore?.model?.username !== "coordinator1" && <Approve />}
            {pb?.authStore?.model?.collectionName === 'supervisors' && pb.authStore?.model?.username === "coordinator1" && <FinalistDetails />}
        </>
    )
}